export default "__VITE_ASSET__CDH0yixy__"